import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { FormMode } from 'src/app/controls/common/form-mode';
import { RichToolTipDirective } from 'src/app/directives/rich-tool-tip.directive';
import { Customer } from 'src/app/models/customer';
import { DocumentType } from 'src/app/models/document-type';
import { ProcessType } from 'src/app/models/enums/process-type';
import { ProcessDefinition } from 'src/app/models/process-definition';
import { CustomersService } from 'src/app/services/customers.service';
import { DocumentTypesService } from 'src/app/services/document-type.service';
import { ProcessDefinitionService } from 'src/app/services/process-definition.service';

@Component({
    selector: 'app-auto-link-form-dialog',
    templateUrl: './auto-link-form-dialog.component.html',
    styleUrls: ['./auto-link-form-dialog.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatOptionModule,
        MatButtonModule,
        NgClass,
        MatDialogClose,
        FontAwesomeModule,
        RichToolTipDirective,
    ]
})
export class AutoLinkFormDialogComponent implements OnInit {
    public faCircleInfo = faCircleInfo;

    public FormMode = FormMode;

    /**
     * Champs du formulaire de saisie du nom.
     */
    public idFormControl = new UntypedFormControl(null);
    public issuerFormControl = new UntypedFormControl(null);
    public customerFormControl = new UntypedFormControl(null);
    public documentTypeFormControl = new UntypedFormControl(null);
    public processDefinitionFormControl = new UntypedFormControl(null, Validators.required);

    // public reminderActionDatasFormControl = new FormControl(null, Validators.required);

    public get isValid(): boolean {
        return this.processDefinitionFormControl.valid;
    }

    customers: Customer[];
    documentTypes: DocumentType[];
    processDefinitions: ProcessDefinition[];

    public title = "Ajout d'un rattachement automatique";

    constructor(
        public dialogRef: MatDialogRef<AutoLinkFormDialogComponent>,
        public customersService: CustomersService,
        public documentTypesService: DocumentTypesService,
        public processDefinitionService: ProcessDefinitionService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit(): void {
        this.loadCustomers();
        this.loadDocumentTypes();
        this.loadProcessDefinitions();

        this.idFormControl.disable();

        if (this.data.mode === FormMode.Reading) {
            this.issuerFormControl.disable();
            this.customerFormControl.disable();
            this.documentTypeFormControl.disable();
            this.processDefinitionFormControl.disable();
        }

        if (this.data.mode === FormMode.Creation) {
            this.title = "Ajout d'un rattachement automatique";
        } else if (this.data.mode === FormMode.Edition) {
            this.title = `Édition du rattachement automatique ${this.data.record.id}`;
        }
        if (this.data.mode === FormMode.Reading) {
            this.title = `Rattachement automatique ${this.data.record.id}`;
        }
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public validate(): void {
        if (this.isValid) {
            this.dialogRef.close(this.data.record);
        }
    }

    loadCustomers() {
        this.customersService.List(null, null, null, null).subscribe((x) => {
            this.customers = x.value;
        });
    }

    loadDocumentTypes() {
        this.documentTypesService.List(null, null, null, null).subscribe((x) => {
            this.documentTypes = x.value;
        });
    }

    loadProcessDefinitions() {
        const definitionContext: Context = new Context('type', ProcessType.AutoLink.toString());
        this.processDefinitionService.List(definitionContext, null, null, null).subscribe((x) => {
            this.processDefinitions = x.value;
        });
    }
}
